import { Link } from "react-router-dom";
import Block from "../components/Block";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" noindex />
      <section className="wrap page-head">
        <h1>Page not found</h1>
        <p className="lede">
          That page doesn't exist — or it moved. Let's get you back on track.
        </p>
      </section>

      <Block marker="404">
        <div className="actions">
          <Link className="btn btn-solid" to="/">Back to home</Link>
          <Link className="btn btn-ghost" to="/contact">Contact us</Link>
        </div>
      </Block>
    </>
  );
}
